import axios from "axios";

const permissionServices = {
   
    async permissionsByuser() {
    
      const response =  await axios.get(
        `${process.env.REACT_APP_ADMIN_API_URL}/api/permissions/byuser`
      );
     
      return response.data;
    },
   
  };
  export default permissionServices;
  